import * as React from 'react';

const SvgOutreachReplied = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3963)">
      <circle cx={21} cy={18} r={14} fill="#AC5BEC" />
    </g>
    <path
      d="M23.76 12.9733L17.74 14.9733C13.6934 16.3266 13.6934 18.5333 17.74 19.88L19.5267 20.4733L20.12 22.26C21.4667 26.3066 23.68 26.3066 25.0267 22.26L27.0333 16.2466C27.9267 13.5466 26.46 12.0733 23.76 12.9733ZM23.9733 16.56L21.44 19.1066C21.34 19.2066 21.2134 19.2533 21.0867 19.2533C20.96 19.2533 20.8334 19.2066 20.7334 19.1066C20.54 18.9133 20.54 18.5933 20.7334 18.4L23.2667 15.8533C23.46 15.66 23.78 15.66 23.9733 15.8533C24.1667 16.0466 24.1667 16.3666 23.9733 16.56Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3963"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3963"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3963"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3963"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgOutreachReplied;
